module.exports = __webpack_public_path__ + "img/pole labs.bab0c818.svg";